@if (series(); as options) {
    <ag-charts class="chart" [options]="options"> </ag-charts>
}
